import { makeStyles, TableCell, Tooltip } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles(theme => {
  const { palette, scrollStyles } = theme;

  return {
    text: {
      color: palette.accent.main,
      cursor: 'pointer',
      userSelect: 'none',
      '&:hover': {
        textDecoration: 'underline'
      }
    },
    tooltip: {
      padding: '.5rem',
      backgroundColor: palette.white,
      maxWidth: '700px',
      border: `1px solid ${palette.grey.medium}`,
      '& span::before': {
        border: `1px solid ${palette.grey.medium}`,
        backgroundColor: palette.white
      }
    },
    tooltipContent: {
      ...scrollStyles,
      overflow: 'auto',
      fontSize: '.8rem',
      letterSpacing: '1px',
      lineHeight: '1.5',
      maxHeight: '300px',
      color: palette.grey.dark
    }
  };
});

const ManagerCell = ({ name, note }) => {
  const classes = useStyles();
  return (
    <TableCell>
      <Tooltip
        title={<div className={classes.tooltipContent}>{note}</div>}
        classes={{ tooltip: classes.tooltip }}
        interactive
        placement="bottom-start"
      >
        <span className={classes.text}>{name}</span>
      </Tooltip>
    </TableCell>
  );
};

ManagerCell.propTypes = {
  name: PropTypes.string.isRequired,
  note: PropTypes.string.isRequired
};

export default ManagerCell;
